module.exports = __webpack_public_path__ + "media/images/lb/040-5d1696f1609570d675e57db6a54b50ed.svg";